
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Cell from 'vux/src/components/cell/index.vue'

export default {
components: {
Group,
XInput,
Cell,
XButton
},
data () {
return {
$vue: '', // 定义vue
name: '', // 姓名
phone: '', // 手机号码
sex: '', // 性别
degree: '', // 学位
hospital: '', // 医院
rid: '', // 身份证
email: '', // 邮箱
isPass: '', // 医生是否通过认证
isBinding: '开发中' 
}
},
methods: {
/*
* 获取医生个人详情信息
*/
async getPersonInfoDetail () {
this.$http.post(this.$vue.getData('PERSONINFO_URL')).then(suc => {
let data = suc.data.data
this.name = data.USER_NAME 
this.phone = data.PHONE 
this.email = data.EMAIL 
this.rid = data.RID 
this.isPass = data.STATUS 
if (data.SEX === '1') {
this.sex = '男'
} else if (data.SEX === '2') {
this.sex = '女'
}
if (data.ACADEMICDEGREE === 1) {
this.degree = '医学学士'
} else if (data.ACADEMICDEGREE === 2) {
this.degree = '医学硕士'
} else if (data.ACADEMICDEGREE === 3) {
this.degree = '医学博士'
}
this.hospital = data.HOSPITAL_NAME 
})
},

goWxBinding () {
this.$http.post(this.$vue.getData('WECHAT_BINDING')).then(suc => {
this.$http.post(suc.data.data).then(success => {
})
})
}
},
beforeMount () {
this.$vue = this
this.getPersonInfoDetail()
},
mounted () {
}
}



// WEBPACK FOOTER //
// ./src/components/doctor/user/personInfoDetail.vue